import Dot from "../../../Components/Dot/Dot";
import style from "./Notification.module.css";
import Svg from "../../../Components/Svg/Svg";
import User from "../../../Services/User";
import SvgOptions from "../../../Components/Svg/SvgOptions";

const Notification = ({ type, children, onClick }) => {
	const { staff, title, createdAt } = children;
	const biodata = User.getBiodata();

	const formatTime = (dateString) => {
		const date = new Date(dateString);
		let hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, "0");
		const ampm = hours >= 12 ? "PM" : "AM";
		hours = hours % 12 || 12;
		return `${hours}:${minutes}${ampm}`;
	};

	let icon = null;
	if (typeof type === "object") {
		icon = type.icon;
	}

	return (
		<div
			onClick={() => onClick(children)}
			className={style[typeof type === "object" ? type.name : "info"]}
		>
			<div className={style.content}>
				<div className={style.subContent}>
					{/* Left icon */}
					<div className={style.circle}>
						<Svg>{SvgOptions.CircleNotification}</Svg>
					</div>

					{/* Text content */}
					<div className={style.margin}>
						<div className={style.text}>
							<span>{staff.firstname + " " + staff.lastname}</span> {title}
						</div>
						<div className={style.time}>{formatTime(createdAt)}</div>
					</div>
				</div>

				{/* Right arrow or icon */}
				{icon ? <Svg>{icon}</Svg> : <Svg>{SvgOptions.Arrow}</Svg>}
			</div>
		</div>
	);
};

export default Notification;
